import React, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { LoaderPage } from "../components";
import { getAuthCredentials } from "../utils/auth-utils";

interface AuthContextType {
  isLoggedIn: boolean;
  login: () => void;
  logout: () => void;
  shopPageSearchValue: string | null;
  setShopPageSearchValue: (searchValue: string) => void;
  cartItems: number;
  setCartItems: (cartItems: number) => void;
  baseProductUuidForAddOn: string;
  setBaseProductUuidForAddOn: (baseProductUuidForAddOn: string) => void;
  signUpEmail: string | null;
  setSignUpEmail: (signUpEmail: string | null) => void;
}

interface AuthProviderProps {
  children: ReactNode;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const [signUpEmail, setSignUpEmail] = useState<string | null>(null);
  const [shopPageSearchValue, setShopPageSearchValue] = useState<string | null>(
    null
  );
  const [cartItems, setCartItems] = useState(0);
  const [baseProductUuidForAddOn, setBaseProductUuidForAddOn] = useState('');

  useEffect(() => {
    const { customerUuid } = getAuthCredentials();
    if (customerUuid) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const { token } = getAuthCredentials();
  // useEffect(() => {
  //   const systemToken = "SyJ1c2VybmFtZSI6ImFiaGlqa";
  //   const systemKey = "2I_wP@krq55$2b$10$7uJ9UlI"
  //   const { encryptedData } = generateEncryptedData(systemToken, systemKey);
  //   console.log(`Encrypted Data: ${encryptedData}`);
  //   const initializeAuth = async () => {
  //     if (!token) {
  //       const request = {
  //         username: process.env.REACT_APP_AUTH_SYSTEM_KEY ?? '',
  //         password: process.env.REACT_APP_AUTH_SYSTEM_PASSWORD ?? '',
  //         userTypeId: 5
  //       };
  //       try {
  //         const response = await userClient.initiateLogin(request);
  //         if (response?.success) {
  //           setAuthCredentials(response?.data.access_token, response?.data.refresh_token);
  //         } else {
  //           // toast.error(response.error);
  //         }
  //       } catch (error) {
  //         console.error('Login API error:', error);
  //         // toast.error('Failed to login. Please try again.');
  //       }
  //     }
  //   };

  //   initializeAuth();
  // }, []);

  const login = () => {
    // Logic for logging in
    setIsLoggedIn(true);
  };

  const logout = () => {
    // Logic for logging out
    setIsLoggedIn(false);
  };

  if (isLoggedIn === null) {
    return <LoaderPage />;
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        login,
        logout,
        shopPageSearchValue,
        setShopPageSearchValue,
        cartItems,
        setCartItems,
        baseProductUuidForAddOn,
        setBaseProductUuidForAddOn,
        signUpEmail,
        setSignUpEmail
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
